const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\x00-\x1F]/g;
const DEFAULT_FILENAME = 'document';
const MAX_FILENAME_LENGTH = 255;

export function sanitizeFilename(filename: string, maxLength = MAX_FILENAME_LENGTH): string {
    const basename = filename.replace(/^.*[\\/]/, '').trim();
    const withoutInvalid = basename
        .replace(INVALID_FILENAME_CHARS, '-')
        .replace(/\s+/g, ' ')
        .trim();
    const withoutDoubleDots = withoutInvalid.replace(/\.{2,}/g, '.');

    let sanitized = withoutDoubleDots;

    if (!sanitized || sanitized === '.' || sanitized === '..') {
        sanitized = DEFAULT_FILENAME;
    }

    if (sanitized.length <= maxLength) {
        return sanitized;
    }

    const dotIndex = sanitized.lastIndexOf('.');
    if (dotIndex <= 0 || dotIndex === sanitized.length - 1) {
        return sanitized.slice(0, maxLength);
    }

    const extension = sanitized.slice(dotIndex);
    const baseMax = maxLength - extension.length;

    if (baseMax <= 0) {
        return sanitized.slice(0, maxLength);
    }

    return sanitized.slice(0, baseMax) + extension;
}
